<template>
  <div>
    <b-card :title="$t('HELP_SUPPORT').Follow_Market">
      <!-- <h4 class="mt-2">Configuração</h4> -->
      <b-row class="mt-2">
        <b-col class="col-12 flex">
          <b-button variant="primary" class="mr-2" @click="restoreLayoutQuotes">
            <span class="">{{ $t('HELP_SUPPORT').Restore_Layout }}</span>
            <!-- <feather-icon icon="RefreshCcwIcon" class="mr-50" /> -->
          </b-button>
          <b-button variant="primary" @click="clearLocalDataQuotes">
            <span class="">{{ $t('HELP_SUPPORT').Clear_Local_Data }}</span>
            <!-- <feather-icon icon="TrashIcon" class="mr-50" /> -->
          </b-button>

        </b-col>
      </b-row>
      <hr>
      <!-- <h4>Dados</h4> -->
       <div class="flex">
         <b-button
           v-b-toggle.data-info
           variant="primary"
           class="flex"
         >
           <feather-icon
             icon="ChevronDownIcon"
             class="mr-50"
           />
           <span class="align-middle">{{$t('HELP_SUPPORT').Detailed_Info}}</span>
         </b-button>

         <!-- <vx-tooltip :text="$t('GENERAL').Copy_Data" position="bottom" delay=".1s">
            <b-button variant="flat-primary" class="btn-icon rounded-circle ml-2" @click.stop="copyInfo" size="sm">
              <feather-icon icon="ClipboardIcon" svgClasses="w-5 h-5"/>
            </b-button>
          </vx-tooltip> -->

         <b-button variant="flat-primary" class="btn-icon rounded-circle ml-2" @click.stop="copyInfo" size="sm" v-b-tooltip.hover.right="$t('GENERAL').Copy_Data" v-if="info.sessionId">
            <feather-icon icon="ClipboardIcon" svgClasses="w-5 h-5"/>
          </b-button>
       </div>

      <!-- <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-toggle.data-info variant="outline-primary">
        Toggle Collapse
      </b-button> -->
      <b-row>
        <b-col class="col-12">
          <b-collapse id="data-info" class="mt-2">
            <pre v-html="formattedInfo" class="pre-json-info"></pre>
          </b-collapse>
        </b-col>
      </b-row>
      <hr>
      <h4>{{$t('HELP_SUPPORT').Layout_History}}</h4>
      <div class="layout-hist-content">
        <b-row>
          <b-col class="col-12" v-if="layoutHist.length == 0">Sem dados histórico</b-col>
          <b-col class="layout-hist-col col-12 mt-4 mb-1" md="4" v-for="(item, index) in layoutHist" :key="index">
            <div class="flex">
              <div style="line-height: 18px;">
                <span class="fw-500">{{ formatFullDateTimezone(item.dt_create, { dateStyle: "medium", timeStyle: "short" }) }}</span>
                <div>
                  <div><small><span class="fw-500">{{ $t('HELP_SUPPORT').Created }}:</span> {{ getMetadataAddDateTime(item) }}</small></div>
                  <div style="margin-top: -5px;"><small><span class="fw-500">{{ $t('HELP_SUPPORT').Updated }}:</span> {{ getMetadataChangeDateTime(item) }}</small></div>
                </div>
              </div>
              <b-button variant="flat-primary" class="btn-icon rounded-circle ml-2" @click.stop="updateHistLayoutQuotes(item)" size="sm">
                <feather-icon icon="UploadCloudIcon" svgClasses="w-5 h-5"/>
              </b-button>
            </div>
            
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { VBToggle, BCollapse, BButton, VBTooltip } from 'bootstrap-vue';
import AppConstants from '../../../appConstants';
import { EventBus } from '../../../event-bus';
import browserInfoHelper from '../../../helpers/browser-info-helper';
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
import messageDialogHelper from '../../../helpers/message-dialog-helper';
import layoutService from '../../../providers/layoutService';
import messagesNotifyHelper from '../../../helpers/messages-notify-helper';
import formatFieldHelper from '../../../helpers/format-field-helper';
import checkDeviceTypeHelper from '../../../helpers/check-device-type-helper';

export default {
  components: { BCollapse, BButton, VBTooltip },
  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      layoutHist: [],
      info: {}
    }
  },
  created() {
    this.loadLayoutHist();
    this.info = {
      sessionId: formatFieldHelper.obfuscateText(this.currentUser.sessionId),
      wdmasid: formatFieldHelper.obfuscateText(this.currentUser.wdmasid),
      correlationId: this.correlationId,
      domain: this.currentUser.domain,
      platform: this.platform,
      screenSize: this.screenSize,
      browserName: this.browserName,
      version: this.version
    };
    if (this.currentUser.requestIp) this.info.requestIp = this.currentUser.requestIp;
    if (this.currentUser.userAgent) this.info.userAgent = this.currentUser.userAgent;
    if (this.currentUser.operatingSystem) this.info.operatingSystem = this.currentUser.operatingSystem;
    if (this.currentUser.browser) this.info.browser = this.currentUser.browser;
  },
  computed: {
    isDesktop() {
      return !checkDeviceTypeHelper.isNativeApp()
    },
    formattedInfo() {
      if (!this.info.sessionId) return this.$t('HELP_SUPPORT').Detailed_Info_No_Data;
      const jsonString = JSON.stringify(this.info, null, 2);
      return jsonString.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    currentUser() {
      return this.$store.state.AppActiveUser;
    },
    correlationId() {
      return this.$store.state.correlationId;
    },
    platform() {
      return browserInfoHelper.getPlatform();
    },
    screenSize() {
      return browserInfoHelper.getScreenSize();
    },
    browserName() {
      return browserInfoHelper.getBrowserName();
    },
    version() {
      return this.$config.version;
    }
  },
  methods: {
    getMetadataChangeDateTime(item) {
      if (this.isDesktop && !item.metadata) return '';
      else if (!this.isDesktop && !item.metadata_mobile) return '';
      const metadataParsed = this.isDesktop ? JSON.parse(item.metadata.data) : JSON.parse(item.metadata_mobile.data);
      return metadataParsed.changeDatetime;
    },
    getMetadataAddDateTime(item) {
      if (this.isDesktop && !item.metadata) return '';
      else if (!this.isDesktop && !item.metadata_mobile) return '';
      const metadataParsed = this.isDesktop ? JSON.parse(item.metadata.data) : JSON.parse(item.metadata_mobile.data);
      // console.log('[metadata][parsed][after]', metadataParsed);
      return metadataParsed.addDatetime ? metadataParsed.addDatetime : metadataParsed.changeDatetime;
    },
    async copyInfo() {
      await this.$copyText(JSON.stringify(this.info));
      messagesNotifyHelper.successNotify(this.$t('HELP_SUPPORT').Copy_Info_Success);
    },
    formatFullDateTimezone(val, obj) {
      return convertDatetimeHelper.formatFullDateTimezone(val, obj);
    },
    formatFullDate(val, obj) {
      return convertDatetimeHelper.formatFullDate(val, obj);
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    loadLayoutHist() {
      const params = new URLSearchParams();
      params.append('limit', 20);
      layoutService.loadLayoutHistWDMA(params)
        .then((res) => {
          this.layoutHist = res;
          console.log('[loadLayoutHist]', this.layoutHist);
        })
        .catch(err => {
          console.log(err);
        })
    },
    clearLocalDataQuotes() {
      messageDialogHelper.displayDialogConfirm(this.$t('HELP_SUPPORT').Clear_Local_Data_Dialog_Title, this.$t('HELP_SUPPORT').Clear_Local_Data_Dialog_Message,
        (callback) => {
          if (callback == "accept") {
            EventBus.$emit(AppConstants.BUS_EVENT_CLEAR_LOCAL_DATA_QUOTES);
          }
        });
    },
    restoreLayoutQuotes() {
      messageDialogHelper.displayDialogConfirm(this.$t('HELP_SUPPORT').Restore_Layout_Dialog_Title, this.$t('HELP_SUPPORT').Restore_Layout_Dialog_Message,
        (callback) => {
          if (callback == "accept") {
            EventBus.$emit(AppConstants.BUS_EVENT_RESTORE_LAYOUT_QUOTES);
          }
        });
    },
    updateHistLayoutQuotes(item) {
      messageDialogHelper.displayDialogConfirm(this.$t('HELP_SUPPORT').Update_Layout_History_Dialog_Title, `${this.$t('HELP_SUPPORT').Update_Layout_History_Dialog_Message} ${this.formatFullDateTimezone(item.dt_create, { dateStyle: 'short', timeStyle: 'short' })} ?`,
        (callback) => {
          if (callback == "accept") {
            EventBus.$emit(AppConstants.BUS_EVENT_UPDATE_HIST_LAYOUT_QUOTES, item);
          }
        });
    },

  }
}
</script>

<style lang="scss">
  .pre-json-info {
    // color: #FFF;
    width: 100%;
    height: 200px;

    background: #f4f4f4;
    padding: 1em;
    border-radius: 4px;
    overflow-x: auto;
    font-family: monospace;
  }
  
</style>